// Language codes are free-form BCP 47-ish strings (e.g. 'en', 'he', 'ar-SA').
// We do not enumerate every possible code; we enumerate only the ones the
// platform ships with first-class support for in onboarding/defaults, and
// check RTL by prefix against a short known list.

export type LanguageCode = string

export const DEFAULT_LANGUAGE: LanguageCode = 'en'

// Known RTL script prefixes per Unicode CLDR. We match by the primary
// subtag (before any '-' region/script) so 'ar-SA', 'he-IL' etc. resolve
// correctly.
const RTL_PRIMARY_SUBTAGS: readonly string[] = [
  'ar', // Arabic
  'arc', // Aramaic
  'az-arab', // Azerbaijani in Arabic script — handled by prefix check below
  'ckb', // Central Kurdish (Sorani)
  'dv', // Divehi
  'fa', // Persian (Farsi)
  'he', // Hebrew
  'iw', // Hebrew (deprecated code)
  'ji', // Yiddish (deprecated code)
  'ku', // Kurdish (when in Arabic script; approximation)
  'ps', // Pashto
  'sd', // Sindhi
  'syr', // Syriac
  'ug', // Uyghur
  'ur', // Urdu
  'yi', // Yiddish
]

export function normalizeLanguageCode(language: LanguageCode | null | undefined): LanguageCode {
  const trimmed = (language ?? '').trim().toLowerCase()
  return trimmed === '' ? DEFAULT_LANGUAGE : trimmed
}

export function isRtl(language: LanguageCode | null | undefined): boolean {
  const lang = normalizeLanguageCode(language)
  const primary = lang.split('-', 1)[0] as string
  return RTL_PRIMARY_SUBTAGS.includes(primary)
}

export function languageDirection(
  language: LanguageCode | null | undefined,
): 'ltr' | 'rtl' {
  return isRtl(language) ? 'rtl' : 'ltr'
}
